import gql from 'graphql-tag';

const conceptosNominaFormulasTableQuery = gql`
    query conceptosNominaFormulas($numberItems: Int!, $numberPage: Int!, $fieldOrder: String!, $Order: SortOrder!) {
        conceptosNominaFormulas(first: $numberItems, page: $numberPage, activo: true, orderBy:[{field: $fieldOrder, order: $Order}]) {
            data {
                id,
                nombre,
                descripcion,
                formula
            }
            paginatorInfo {
                count
                currentPage
                firstItem
                lastItem
                hasMorePages
                lastPage
                perPage
                total
            }
        }
    }
`

const queries = { conceptosNominaFormulasTableQuery };

export default queries;
